import {
  ProjectTypeStateTypes,
  ProjectTypeActionTypes,
} from "./ProjectType.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ProjectTypeStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ProjectTypeReducer = (
  state: ProjectTypeStateTypes = INITIAL_STATE,
  action: any
): ProjectTypeStateTypes => {
  switch (action.type) {
    case ProjectTypeActionTypes.FETCH_ALL_PROJECT_TYPE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProjectTypeActionTypes.FETCH_ALL_PROJECT_TYPE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProjectTypeActionTypes.FETCH_ALL_PROJECT_TYPE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProjectTypeActionTypes.FETCH_ALL_PROJECT_TYPE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ProjectTypeActionTypes.FETCH_ONE_PROJECT_TYPE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProjectTypeActionTypes.FETCH_ONE_PROJECT_TYPE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProjectTypeActionTypes.FETCH_ONE_PROJECT_TYPE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProjectTypeActionTypes.FETCH_ONE_PROJECT_TYPE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ProjectTypeReducer;
